import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import PayementRHService from "../../../../services/RHService/PayementRHService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import UtilsFormule from "../../../../utils/UtilsFormule";
import ListTotalPayementBill from "../../../../components/finance/payement/ListTotalPayementBill";
import MethodePayementSalaireTotal from "./Payement/MethodePayementSalaireTotal";
import MethodePayementSalaireAvance from "./Payement/MethodePayementSalaireAvance";

const PayerSalaire = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [salaireDetails, setSalaireDetails] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [buttonClicked, setButtonClicked] = useState("");
  const [ChoosePayement, setChoosePayement] = useState("");

  useEffect(() => {
    startLoading();
    PayementRHService.getPayementEmployeSalaireBySociete(
      getCurrentUserId(),
      localStorage.getItem("salaireId"),
      localStorage.getItem("monthRH"),
      localStorage.getItem("yearRH")
    )
      .then((response) => {
        console.log(response);
        if (response.data["error"]) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :  " + response.data["error"]);
        } else if (response.data["empty"]) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :  " + response.data["empty"]);
        } else {
          setSalaireDetails(response?.data?.success);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const buttonPayement = () => {
    if (salaireDetails?.salary.payed === 0) {
      return (
        <button
          type="submit"
          onClick={(e) => {
            setButtonClicked("clicked");
          }}
          className="btn btn-dark float-right"
        >
          Payer
        </button>
      );
    } else if (salaireDetails?.salary.payed === 1) {
      return (
        <button
          disabled
          type="submit"
          // onClick={(e) => {
          //   setButtonClicked("clicked");
          // }}
          className="btn btn-dark float-right"
        >
          Payée
        </button>
      );
    }
  };

  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setChoosePayement(payement);
  };
  const payementChooseUI = () => {
    localStorage.setItem("IdSalary",salaireDetails?.salary.id);
    localStorage.setItem("restToPay",salaireDetails?.restToPay);
    localStorage.setItem("IdEmployeRH",salaireDetails?.salary.user?.id)
    if (ChoosePayement === "TOTAL") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">2-Deuxième étape:</h3>
                </div>
                <MethodePayementSalaireTotal />
              </div>
            </div>
          </div>
        </section>
      );
    } else if (ChoosePayement === "AVANCE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">2-Deuxième étape: </h3>
              </div>
              <MethodePayementSalaireAvance />
            </div>
          </div>
        </div>
      );
    }
  };

  const DynamiquePayement = () => {
    if (buttonClicked === "clicked") {
      return (
        <section className="content-header">
          <div className="card card-dark ">
            <div className="card-header">
              <h3 className="card-title">1-Première étape: </h3>
              <br />
            </div>

            <div className="card-body">
              <h5 className="card-title">
                Choisir de payer la totalité du montant ou une avance
              </h5>
              <div class="row">
                <div class="col-2"></div>
                <div class="col-10">
                  <select
                    class="form-control"
                    onChange={(e) => handleChangePayement(e)}
                  >
                    <option key={0} value={0}>
                      Payer
                    </option>
                    <option key={1} value={"TOTAL"}>
                      La totalité du montant
                    </option>
                    <option key={2} value={"AVANCE"}>
                      Une avance
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {payementChooseUI()}
        </section>
      );
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {salaireDetails && (
        <section className="content-header">
          <div className="container-fluid">
            <div className="card card-dark">
              <div className="card-header">
                Salaire de : {salaireDetails?.salary.user?.firstName}{" "}
                {salaireDetails?.salary.user?.lastName}
                <small className="float-right">
                  Date:{" "}
                  {UtilsFormule.formatDate(
                    salaireDetails?.salary?.creationDate
                  )}
                </small>
              </div>{" "}
              <div className="card-body">
                <div className="row">
                  <div class="col-6"></div>
                </div>
                <div className="row">
                  <div class="col-7"></div>
                  <div class="col-5">
                    <div className="table-responsive ">
                      <table className="table">
                        <tbody>
                          <tr>
                            <th style={{ width: "50%" }}>Total :</th>
                            <td>{salaireDetails?.allToPay} DNT</td>
                          </tr>
                          <tr>
                            <th style={{ width: "50%" }}>Reste à payer :</th>
                            <td>{salaireDetails?.restToPay} DNT</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">{buttonPayement()}</div>
            </div>
          </div>
        </section>
      )}

      <br />
      {DynamiquePayement()}
      <section className="content-header">
        <div className="container-fluid">
          {salaireDetails?.payementInformationEmploye !== null ? (
            <ListTotalPayementBill
              payementInformations={salaireDetails?.payementInformationEmploye}
            />
          ) : null}
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(PayerSalaire);
